import {
  CodeOutlined,
  CopyOutlined,
  EditOutlined,
  ExperimentOutlined,
  ReadOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons"
import React from "react"
import { css } from "styled-components"
import { BT } from "../styles/blog-typography"
import Text from "./text"

interface IArticleTypeProps {
  colour:
    | "burnt-orange"
    | "copper"
    | "magenta"
    | "purple"
    | "emerald"
    | "turquoise"
  children: any
}

/**
 * Article Media type
 * @param colour - colour of the media type text
 */
const ArticleType = ({ colour, children }: IArticleTypeProps) => {
  return (
    <Text
      as="p"
      variants={[
        css`
          ${BT.sm.info`500`};
          color: ${`var(--${colour})`};
        `,
      ]}
    >
      {children}
    </Text>
  )
}

ArticleType.Article = () => (
  <ArticleType colour="burnt-orange">
    <EditOutlined />
    Article
  </ArticleType>
)

ArticleType.Video = () => (
  <ArticleType colour="copper">
    <VideoCameraOutlined />
    Video
  </ArticleType>
)

ArticleType.Whitepaper = () => (
  <ArticleType colour="magenta">
    <CopyOutlined />
    Whitepaper
  </ArticleType>
)

ArticleType.CaseStudy = () => (
  <ArticleType colour="purple">
    <ExperimentOutlined />
    Case Study
  </ArticleType>
)

ArticleType.Ebook = () => (
  <ArticleType colour="emerald">
    <ReadOutlined />
    E-book
  </ArticleType>
)

ArticleType.DevContent = () => (
  <ArticleType colour="turquoise">
    <CodeOutlined />
    Dev Content
  </ArticleType>
)

export default ArticleType
